import { ComponentRef } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { ModalCloseData } from './modal.interface';

export class ModalRef<T> {
    private readonly _afterClosed = new Subject<any>();
    afterClosed: Observable<any> = this._afterClosed.asObservable();
    private _componentRef: ComponentRef<any>;

    public close(data: ModalCloseData = {}) {
        this._afterClosed.next(data);
    }

    public get componentInstance(): T {
        if (this._componentRef) {
            return this._componentRef.instance;
        }
    }

    public setComponentRef(componentRef: ComponentRef<T>) {
        this._componentRef = componentRef;
    }

    public get modalInstance(): ModalRef<T> {
        return this;
    }
}
